import React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useDispatch } from 'react-redux';
import { getDocs } from '../preferences/preferenceApi';
import { setSourceDocs } from '../preferences/preferenceSlice';
// REMOVED: AWS SDK - migrated to Firebase Storage
// import AWS from 'aws-sdk';
import useAuth from 'hooks/useAuth';
import { setIsUploadedFiles } from 'store/slices/uploadedfile';
//Material UI
import { Button } from '@mui/material';

import { TagsInput } from 'react-tag-input-component';

const project = 'document';

function removeAccents(str) {
    var AccentsMap = [
        'aàảãáạăằẳẵắặâầẩẫấậ',
        'AÀẢÃÁẠĂẰẲẴẮẶÂẦẨẪẤẬ',
        'dđ',
        'DĐ',
        'eèẻẽéẹêềểễếệ',
        'EÈẺẼÉẸÊỀỂỄẾỆ',
        'iìỉĩíị',
        'IÌỈĨÍỊ',
        'oòỏõóọôồổỗốộơờởỡớợ',
        'OÒỎÕÓỌÔỒỔỖỐỘƠỜỞỠỚỢ',
        'uùủũúụưừửữứự',
        'UÙỦŨÚỤƯỪỬỮỨỰ',
        'yỳỷỹýỵ',
        'YỲỶỸÝỴ'
    ];
    for (var i = 0; i < AccentsMap.length; i++) {
        var re = new RegExp('[' + AccentsMap[i].substring(1) + ']', 'g');
        var char = AccentsMap[i][0];
        str = str.replace(re, char).replace(/\s/g, '');
    }
    return str;
}

export default function Upload({ modalState, setModalState, projectName, projectSubname, fetchUploadedFiles, pathFolder }) {
    const [docName, setDocName] = useState(projectName);
    const [files, setfiles] = useState([]);
    const [progress, setProgress] = useState();
    const [selected, setSelected] = useState(['papaya']);

    const apiHost = process.env.REACT_APP_API_URL;

    // REMOVED: AWS S3 configuration - now using Firebase Storage via backend
    // const S3_BUCKET = 'youteach.ai';
    // const REGION = 'ap-southeast-1';

    const { fetchBillings, billings } = useAuth();

    useEffect(() => {
        setDocName(projectName);
    }, [docName, projectName]);

    useEffect(() => {
        const size_available = parseFloat(billings.total_size) < parseFloat(billings.limit_size);
        const token_available = parseInt(billings.total_token) < parseFloat(billings.limit_token);
        const price_availabel = parseFloat(billings.total_prices) < parseFloat(billings.limit_price);
        // console.log(!size_available || !token_available || !price_availabel)
        if (!size_available || !token_available || !price_availabel) {
            setProgress({ type: 'FAIL', percentage: 0 });
        }
    }, []);

    // REMOVED: AWS S3 client - backend now handles Firebase Storage uploads
    // All file uploads go through backend API which uses Firebase Storage (GCS)

    function Progress({ title, isCancellable = false, isFailed = false }) {
        return (
            <div className="mt-5 flex flex-col items-center gap-2">
                <p className="text-xl tracking-[0.15px]">{title}...</p>
                <p className="text-sm text-gray-2000">Quá trình sẽ mất vài phút</p>
                <p className={`ml-5 text-xl text-red-400 ${isFailed ? '' : 'hidden'}`}>
                    Vượt quá giới hạn tokens, vui lòng xem xét tải lên tài liệu nhỏ hơn
                </p>
                <p className="mt-10 text-2xl">{progress?.percentage || 0}%</p>

                <div className="mb-10 w-[50%]">
                    <div className="h-1 w-[100%] bg-purple-30"></div>
                    <div
                        className={`relative bottom-1 h-1 bg-purple-30 transition-all`}
                        style={{ width: `${progress?.percentage || 0}%` }}
                    ></div>
                </div>

                <button
                    onClick={() => {
                        setDocName('');
                        setfiles([]);
                        // setProgress(undefined);
                        setModalState('INACTIVE');
                        fetchBillings();
                    }}
                    className={`rounded-3xl bg-purple-30 px-4 py-2 text-sm font-medium text-white ${isCancellable ? '' : 'hidden'}`}
                >
                    Hoàn thành
                </button>
            </div>
        );
    }

    function UploadProgress() {
        return <Progress title="Đang tải lên"></Progress>;
    }

    function TrainingProgress() {
        const dispatch = useDispatch();
        useEffect(() => {
            (progress?.percentage ?? 0) < 100 &&
                setTimeout(() => {
                    // console.log(progress)
                    fetch(`${apiHost}/api/task_status?task_id=${progress?.taskId}`)
                        .then((data) => data.json())
                        .then((data) => {
                            if (data.status == 'SUCCESS') {
                                if (data.result.limited === true) {
                                    getDocs().then((data) => dispatch(setSourceDocs(data)));
                                    setProgress(
                                        (progress) =>
                                            progress && {
                                                ...progress,
                                                percentage: 100,
                                                failed: true
                                            }
                                    );
                                } else {
                                    getDocs().then((data) => dispatch(setSourceDocs(data)));
                                    setProgress(
                                        (progress) =>
                                            progress && {
                                                ...progress,
                                                percentage: 100,
                                                failed: false
                                            }
                                    );
                                }

                                dispatch(setIsUploadedFiles(true));
                            } else if (data.status == 'PROGRESS') {
                                setProgress(
                                    (progress) =>
                                        progress && {
                                            ...progress,
                                            percentage: data.result.current
                                        }
                                );
                            }
                        });
                }, 5000);
        }, [progress, dispatch]);
        return (
            <Progress
                title="Đang tiến hành huấn luyện Chatbot"
                isCancellable={progress?.percentage === 100}
                isFailed={progress?.failed === true}
            ></Progress>
        );
    }

    const onDrop = useCallback((acceptedFiles) => {
        setfiles(acceptedFiles);
        // setDocName(acceptedFiles[0]?.name);
    }, []);

    const doNothing = () => undefined;

    // REMOVED: Direct S3 upload function
    // All uploads now go through backend API which handles Firebase Storage
    // Backend uses GCS (Google Cloud Storage) which is Firebase Storage backend

    const uploadFile = async () => {
        const formData = new FormData();
        files.forEach((file) => {
            formData.append('files', file);
        });
        // UPDATED: Removed S3 upload call - backend will handle storage
        // uploadFiles(formData, localStorage.getItem('user_token'));

        formData.append('user_token', localStorage.getItem('user_token'));
        formData.append('project_name', projectName);
        formData.append('folder_name', pathFolder);
        formData.append('labels', selected.join('|'));

        const xhr = new XMLHttpRequest();
        xhr.upload.addEventListener('progress', (event) => {
            const progress = +((event.loaded / event.total) * 100).toFixed(2);
            setProgress({ type: 'UPLOAD', percentage: progress });
        });
        xhr.onload = () => {
            fetchUploadedFiles();
            setModalState('INACTIVE');
            setProgress({ type: 'UPLOAD', percentage: 100 });
        };
        xhr.onerror = () => {
            setProgress({ type: 'FAIL', percentage: 0 });
            console.error('Upload failed');
        };
        xhr.open('POST', `${apiHost + '/projects/document/upload'}`);
        xhr.send(formData);
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        multiple: true,
        onDragEnter: doNothing,
        onDragOver: doNothing,
        onDragLeave: doNothing,
        maxSize: 25000000,
        accept: {
            'application/pdf': ['.pdf'],
            'text/plain': ['.txt'],
            'text/x-rst': ['.rst'],
            'text/x-markdown': ['.md'],
            'application/zip': ['.zip'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
        }
    });

    let view;
    if (progress?.type === 'UPLOAD') {
        view = <UploadProgress></UploadProgress>;
    } else if (progress?.type === 'TRAINIING') {
        view = <TrainingProgress></TrainingProgress>;
    } else if (progress?.type === 'FAIL') {
        view = (
            <>
                <p className="text-xl text-jet">Thêm tài liệu mới</p>
                <p className="mb-3 text-xs text-gray-4000">Đã vượt hạn mức cho phép. Vui lòng kiểm tra hóa đơn</p>
                <button
                    onClick={() => {
                        // setDocName('');
                        // setfiles([]);
                        setModalState('INACTIVE');
                    }}
                    className="p-2 font-medium"
                >
                    Quay lại
                </button>
            </>
        );
    } else {
        view = (
            <>
                <p className="text-xl text-jet">Upload Files</p>
                {/* <input
                    type="text"
                    className="h-10 w-[60%] rounded-md border-2 border-gray-5000 px-3 outline-none"
                    disabled
                    value={projectSubname}
                ></input> */}
                <div className="h-[100%] w-[100%] rounded-md px-0">
                    <div className="relative left-2">
                        <span className="bg-white px-0 text-xs text-gray-4000">Tên tag</span>
                    </div>
                    <TagsInput
                        // className="h-10 w-[100%] rounded-md border-2 border-gray-5000 px-3 outline-none"
                        className="h-10"
                        value={selected}
                        onChange={setSelected}
                        name="labels"
                        placeHolder="enter labels"
                    />
                    <em>press enter or comma to add new tag</em>
                </div>
                <div {...getRootProps()}>
                    <span className="relative rounded-md border border-purple-30 px-4 py-2 font-medium text-purple-30 hover:cursor-pointer ml-1">
                        <input type="button" {...getInputProps()} />
                        Chọn tệp tin (có thể chọn nhiều)
                    </span>
                </div>
                <p className="mb-3 text-xs text-gray-4000">
                    Vui lòng upload định dạng .pdf, .txt, .rst, .docx, .md, .zip, xlsx dung lượng dưới 25mb
                </p>
                <div className="mt-3">
                    <p className="mb-5 font-medium text-eerie-black">Các tệp đã upload</p>
                    <div className="max-h-[20rem] overflow-y-auto">
                        {files.map((file) => (
                            <p key={file.name} className=" text-gray-6000">
                                {file.name}
                            </p>
                        ))}
                        {files.length === 0 && <p className="text-gray-6000">Trống</p>}
                    </div>
                </div>
                <div className="flex flex-row-reverse">
                    <Button
                        onClick={() => {
                            uploadFile();
                            setDocName('');
                            setfiles([]);
                            // setProgress(undefined);
                            setModalState('INACTIVE');
                            // fetchBillings();
                        }}
                        variant="contained"
                        sx={{ backgroundColor: '#156DA2', marginLeft: 1 }}
                        disabled={files.length === 0} // Disable the Button if no file is selected
                    >
                        Xử lý
                    </Button>
                    <Button
                        onClick={() => {
                            setDocName('');
                            setfiles([]);
                            setModalState('INACTIVE');
                        }}
                        variant="outlined"
                        color="secondary"
                    >
                        Thoát
                    </Button>
                </div>
            </>
        );
    }

    return (
        <article
            className={`${modalState === 'ACTIVE' ? 'visible' : 'hidden'} z-9999 fixed left-0  top-0 h-screen  w-screen bg-gray-alpha`}
        >
            <article className="mx-auto mt-24 flex w-[90vw] max-w-lg  flex-col gap-4 rounded-lg bg-white p-6 shadow-lg">{view}</article>
        </article>
    );
}
// TODO: sanitize all inputs
